import React, {Component} from 'react'
import './ModeFinish.sass'
import Report from '../../Report/Report'
import {Link} from 'react-router-dom'


class ModeFinish extends Component {
  state = {
    time: '2.2'
  }

  componentDidMount() {
    const link = document.querySelector("#root > div > aside > div.aside-point > a:nth-child(5)")
    link.classList.add('aside-point__active')

    const input2 = JSON.parse(localStorage.getItem('InputParams2'))

    const time = (( 2 * input2.length / 30 ) * ( input2.width / 13 ) * ( 0.27 / 0.005 )).toFixed(2)
    this.setState({ time })
  }

  render() {
    return (

      <React.Fragment>

        <main className="params">

          <h1 className="params__title">
            Режим резания для окончательного шлифования торцом круга
          </h1>

          <div className="params-content">

            <div className="params-content-descr mode-center">

              <div className="params-label second-input road-input">

                <span className="params-label__item road-input__item mode-input__item">Скорость резания. м/c</span>
                <span className="params-label__value road-input__value mode-input__value">15...30</span>

              </div>

              <div className="params-label second-input road-input">

                <span className="params-label__item road-input__item mode-input__item">Скорость детали, м/мин</span>
                <span className="params-label__value road-input__value mode-input__value">12</span>

              </div>

              <div className="params-label second-input road-input">

                <span className="params-label__item road-input__item mode-input__item">Вертикальная подача, мм </span>
                <span className="params-label__value road-input__value mode-input__value">0,015</span>

              </div>

              <div className="params-label second-input road-input">

                <span className="params-label__item road-input__item mode-input__item">Мощность резания, кВт</span>
                <span className="params-label__value road-input__value mode-input__value">0,51</span>

              </div>

              <div className="params-label second-input road-input">

                <span className="params-label__item road-input__item mode-input__item">Время обработки, мин</span>
                <span className="params-label__value road-input__value mode-input__value">{this.state.time}</span>

              </div>

            </div>

            <div className="mode-link">
              <Link to='/modules/mode/start' className="mode-link__prev">
              </Link>
            </div>

          </div>

        </main>

        <Report/>

      </React.Fragment>

    )
  }
}

export default ModeFinish